import { useQuery } from './query';

export const ADMIN_FEATURES_PATH = '/api/admin/features';

export interface AdminFeatures {
  adminRedesign: boolean;
  /** The affiliate program's page (PERZO_AFFILIATES); absent while off. */
  affiliates?: boolean;
  marketingInbox?: boolean;
  marketingAutopilot?: boolean;
  marketingAutopilotDryRun?: boolean;
  marketingAutopilotAds?: boolean;
  marketingAutopilotVideo?: boolean;
  marketingAutopilotReasons?: { inbox?: string | null; ads?: string | null; video?: string | null };
}

/** A failed capability check deliberately has no value: callers keep the established UI. */
export function useAdminFeatures(enabled = true) {
  return useQuery<AdminFeatures>(enabled ? ADMIN_FEATURES_PATH : null);
}

/**
 * The admin redesign release flag (server PERZO_ADMIN_REDESIGN). null while loading; false on any
 * error, so a failed check keeps the previous admin rather than half of each.
 */
export function useAdminRedesign(enabled = true): boolean | null {
  const q = useAdminFeatures(enabled);
  if (!enabled) return false;
  if (q.data) return q.data.adminRedesign === true;
  return q.error ? false : null;
}
